import React from 'react'
import { Calendar, CalendarOptions } from '@ionic-native/calendar'
import { parseDate } from '../helpers/format_date'
import { WalkI } from "../interfaces/Walk"
import { IonCard, IonContent, isPlatform } from "@ionic/react";
import ModalHeader from './ModalHeader';
import Api from "../services/Api"

export interface CalendarInterface {
  id: number;
  name: string;
  displayname: string;
  isPrimary: boolean;
}

interface ComponentProps {
  exitCal: Function,
  walk: WalkI,
  removeWalk?: WalkI,
  action: string
}

interface ComponentState {
  readWrite: boolean
  selectedCalendar: number
  message: string
  calendars: Array<CalendarInterface>
  gotCalendars: boolean
}

export default class WalkCalendar extends React.Component<ComponentProps, ComponentState> {
  private api = Api.getInstance()

  private calOptions: CalendarOptions | undefined

  state = {
    readWrite: false,
    message: '',
    selectedCalendar: 0,
    calendars: [],
    gotCalendars: false
  }

  componentDidMount() {
    // console.log('--- asking read/write permission')
    // Calendar.hasReadWritePermission().then(result => {
    //   this.setState({readWrite: result})
    //   if (result) {
    //   } else {
    //     Calendar.requestReadPermission()
    //   }
    // }, error => {
    //   console.log('--- error asking permission: ' + error)
    // }).catch(err => {
    //   console.log('--- error caubht: ' + err)
    // })

    
    this.calOptions = Calendar.getCalendarOptions();

    if (this.props.action === 'add') {
      this.listCalendars()
    } else if (this.props.action === 'delete') {
      this.deleteEvent()
    } else {
      this.setState({message: 'Fel action: ' + this.props.action})
    }
  }

  private listCalendars = () => {
    Calendar.listCalendars().then((cals: Array<any>) => {
      const calendars: Array<CalendarInterface> = [];
      for (const cal of cals) {
        // console.log('--- Found cal: ' + JSON.stringify(cal));
        if (isPlatform('android')) {
          if (cal.isPrimary) {
            calendars.push(cal);
          }
        } else {
          // console.log('--- ios cal name ' + cal.name)
          if (cal.name !== 'Birthdays') {
            calendars.push(cal)
          }
        }

      }
      this.setState({calendars: calendars, gotCalendars: true})
    })
  }


  private addEvent = (calendarId: number, calendarName: string) => {
    // ios only
    // Calendar.createCalendar('Walking Talking').then(result => {
    //   console.log(result)
    // })
    const title = this.props.walk.name
    const startDate = parseDate(this.props.walk.start)
    const endDate = new Date(startDate.getTime() + this.props.walk.lengthMinutes * 60000)

    if (this.calOptions) {
      if (isPlatform('android')) {
        this.calOptions.calendarId = calendarId
      } else {
        this.calOptions.calendarName = calendarName
      }

      Calendar.createEventWithOptions(title,undefined,undefined,startDate,endDate,this.calOptions).then(
        (msg) => {
          // console.log('created event: ', JSON.stringify(msg))
          this.setState({message: this.api.tr('added_to_cal')})
          this.props.exitCal('add')
        }, (err) => {
          console.log('created err: ', err)
          this.setState({message: 'Fel: ' + err})
        }).catch(reason => {
        console.log('----- fail:', reason)
        this.setState({message: 'Fel: ' + reason})
      })
    } else {
      console.log('No cal options!?')
    }

  }

  private doDeleteEvent = (title: string, startDate: Date, endDate: Date) => {
    Calendar.deleteEvent(title,undefined,undefined,startDate,endDate).then(
      (msg) => {
        console.log('deleted event: ', JSON.stringify(msg))
      }, (err) => {
        console.log('created err: ', err)
      }).catch(reason => {
      console.log('----- fail:', reason)
    })
  }

  private doDeleteEventNamed = (title: string, startDate: Date, endDate: Date, calendarName: string) => {
    Calendar.deleteEventFromNamedCalendar(title,undefined,undefined,startDate,endDate, calendarName).then(
      (msg) => {
        console.log('deleted event: ', JSON.stringify(msg))
      }, (err) => {
        console.log('created err: ', err)
      }).catch(reason => {
      console.log('----- fail:', reason)
    })
  }
  
  private deleteEvent = () => {
    const title = this.props.walk.name
    const startDate = parseDate(this.props.walk.start)
    const endDate = new Date(startDate.getTime() + this.props.walk.lengthMinutes * 60000)

    if (isPlatform('android')) {
      this.doDeleteEvent(title, startDate, endDate);
    } else if (isPlatform('ios')) {
      Calendar.listCalendars().then((cals: Array<any>) => {
        for (const cal of cals) {
          if (cal.name !== 'Birthdays') {
            this.doDeleteEventNamed(title, startDate, endDate, cal.name);
          }
        }
      })
    }
    this.props.exitCal('delete')
  }

  
  // private modifyEvent = () => {
  //   if (!this.props.removeWalk) {
  //     console.log('------ Missing removeWalk')
  //     this.props.exitCal()
  //     return
  //   }
  //   const removeTitle = this.props.removeWalk.name
  //   const removeStartDate = parseDate(this.props.removeWalk.start)
  //   const removeEndDate = new Date(removeStartDate.getTime() + this.props.removeWalk.lengthMinutes * 60000)
  //   Calendar.deleteEvent(removeTitle,undefined,undefined,removeStartDate,removeEndDate).then(
  //     (msg) => {
  //       console.log('deleted event: ', JSON.stringify(msg))
  //       this.addEvent()
  //     }, (err) => {
  //       console.log('deleted err: ', err)
  //     }).catch(reason => {
  //       console.log('----- fail:', reason)
  //     })
  // }

  render() {
    if (this.props.action === 'delete') {
      return (
        <div>
          { this.state.message }
        </div>
      )
    }
    return (
      <>
        <ModalHeader 
          pageTitle={this.api.tr('add_to_calendar')}
          closeModal={() => this.props.exitCal('cancel')}/>
        <IonContent>
          <div className="cheap_desktop">
            <div className="m-4">
              <p className="mt-4 infoArea">
                {this.api.tr('available_calendars')}
              </p>
              {
                this.state.calendars.map((calendar: CalendarInterface) => {
                  return (
                    <IonCard 
                      onClick={() => this.addEvent(calendar.id, calendar.name)}
                      className="mt-4 p-2 color_green" 
                      key={"calendar_" + calendar.id}>
                      {calendar.name}
                    </IonCard>
                  )
                })
              }
              {
                this.state.calendars.length === 0 ?  
                <IonCard
                  className="mt-4 p-2 text_center">
                  <p>{this.api.tr('no_calendars')}</p>
                </IonCard>
                : null
              }
              <div className="mt-16 text_center color_green" onClick={() => this.props.exitCal('cancel')}>
                {this.api.tr('cancel')}
              </div>
            </div>
          </div>
        </IonContent>
      </>
    )
  }
}
